import { render, staticRenderFns } from "./xiaocheDetail.vue?vue&type=template&id=29172e7c&scoped=true&"
import script from "./xiaocheDetail.vue?vue&type=script&lang=js&"
export * from "./xiaocheDetail.vue?vue&type=script&lang=js&"
import style0 from "./xiaocheDetail.vue?vue&type=style&index=0&id=29172e7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29172e7c",
  null
  
)

export default component.exports